"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndustriesContract = void 0;
const core_1 = require("@ts-rest/core");
const industries_request_1 = require("./industries.request");
const industries_response_1 = require("./industries.response");
const c = (0, core_1.initContract)();
exports.IndustriesContract = c.router({
    listChildrenById: {
        method: 'GET',
        path: '/:industryId',
        responses: { 200: industries_response_1.IndustryListChildrenResponseSchema },
        pathParams: industries_request_1.IndustryIdPathParamsSchema,
    },
    listRoots: {
        method: 'GET',
        path: '/',
        responses: { 200: industries_response_1.IndustryListRootsResponseSchema },
    },
}, { pathPrefix: '/industries' });
